module.exports = __webpack_public_path__ + "4f07308c0f66ed3071804505dc80a843.svg";